import { RoleCode } from "./Constant";

// eslint-disable-next-line import/prefer-default-export
export const permissionAndRoleCheck = (
  permissions: string[],
  activeView: string,
  userRoleCode: string | null
) => {
  const validRoleCodes = Object.values(RoleCode);

  return (
    (userRoleCode !== null && validRoleCodes.includes(userRoleCode)) ||
    permissions?.includes(activeView)
  );
};

export const isAdmin = (userRoleCode: string | null) => {
  return userRoleCode === RoleCode.COMPANY_ADMIN;
};

export const checkViewPermission = (
  permissions: string[],
  activeView: string
) => {
  return permissions.includes(activeView);
};

const getActionList = (permissions, screenCode) => {
  const actionList =
    permissions?.length > 0
      ? permissions?.find((el) => el?.screen?.screenCode === screenCode)
          ?.actionList || []
      : [];
  return actionList;
};

export const checkPermission = (
  permissions,
  screenCode,
  activeView,
  type = "ACTION"
): boolean => {
  const actionList = getActionList(permissions, screenCode);
  return actionList.some(
    (el) => el?.type === type && el?.actionCode === activeView
  );
};
